import { useCallback, useState } from "react";
import { OrderingForSaleProps } from "../components/main/detailsOrder.props";
import { ConfigServer } from "../configs/config.server";
import { useCreateOrdering } from "./useCreateOrdering";
import { CustomerPaymentState } from "../types/types";
import { OrderingForSaleService } from "../services/orderingForSale.service";
import Router from 'next/router';
import { InternetAcquiringEnum } from "../interfaces/ordering/crm/internetAcquiringEnum";
import { PaymentAccountForPartnersIdParam } from "../interfaces/ordering/paymentAccountForPartnersIdParam";
import { PaymentTypeForOrder } from "../interfaces/ordering/paymentTypeForOrder";
import _ from "lodash";
import { PaymentService } from "../services/payment.service";
import { CreatePaymentLinkParameters } from "../interfaces/yandexPay/createPaymentLinkParameters";
import { PaymentTypeEnum } from "../interfaces/yandexPay/paymentTypeEnum";

export const usePaySplit = (props: OrderingForSaleProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const config = ConfigServer(props.hostName);
  const createOrdering = useCreateOrdering(props, config);

  const paySplit = useCallback(async (model: CustomerPaymentState) => {
    setIsLoading(true);

    try {
      const orderingForSale = { ...props.orderingForSale };

      if (orderingForSale.orderingId) {
        const url = await OrderingForSaleService.getPayUrlInternetAcquiringOnOrderingV2(orderingForSale.orderingId, InternetAcquiringEnum.YandexPay, config.ServiceOrdering.GetPayUrlInternetAcquiringOnOrderingV2);
        
        if (url) {
          Router.push(url);
          return;
        }
      }

      if (orderingForSale?.customer && !orderingForSale.orderingId) {
        orderingForSale.customer.email = model.email;
        orderingForSale.customer.firstName = model.firstName;
        orderingForSale.customer.lastName = model.lastName;

        const phoneDigits = model.phone.replace(/\D/g, '');
        orderingForSale.customer.phone = parseInt(phoneDigits, 10);
      }

      if (props.preOrderingId && !orderingForSale.orderingId) {
        const newOrderingId = await createOrdering(model);
        if (newOrderingId) {
          orderingForSale.orderingId = newOrderingId;
        }
      }

      const parameters: PaymentAccountForPartnersIdParam = {
        partnersId: props.orderingForSale.partnerId,
        paymentType: PaymentTypeForOrder.YandexPay,
        offerIdList: _.compact(_.map(props.orderingForSale.positionList, 'offersId')),
        priceLevelIdList: _.compact(_.map(props.orderingForSale.positionList, 'priceLevelId'))
      };

      const paymentAccountResult = await PaymentService.getPaymentAccountForPartnersId(parameters, config.ServiceOrdering.GetPaymentAccountForPartnersId);

      if (paymentAccountResult) {
        if (paymentAccountResult !== '') {
          orderingForSale.accountNumber = paymentAccountResult;
        }
      }

      const paymentYandexPaymentType: CreatePaymentLinkParameters = {
        isTest: config.Mode === 'prod' ? false : true,
        accountPayment: orderingForSale.accountNumber,
        webSitesName: config.WebSitesName,
        orderingId: orderingForSale.orderingId!,
        paymentType: PaymentTypeEnum.Split
      };

      const createPaymentResult = await PaymentService.requestCreateOrderPaymentLink(paymentYandexPaymentType, config.ServiceInternetAcquiring.RequestCreateOrderPaymentLink);

      if (createPaymentResult && !createPaymentResult.isError) {
        Router.push(createPaymentResult.paymentUrl);
      }
    } catch (error) {
      console.error('Pay split error:', error);
      // Здесь можно добавить уведомление об ошибке для пользователя
    } finally {
      setIsLoading(false);
    }
  }, [props, config, createOrdering]);

  return { paySplit, isLoading };
};